<ng-template appTemplatePortal>
    <mat-spinner [diameter]="50"></mat-spinner>
</ng-template>
